var CalendarHorizontal = (function ($) {

    CalendarHorizontal = function (options) {
        var that = this;

        that.selectors = {
            calendar_week_list: '.js-calendar-week-list',
            week_slide_prev: '.js-week-slide-prev',
            week_slide_next: '.js-week-slide-next'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$list = that.$wrapper.find(that.selectors.calendar_week_list);

        // TEMPLATES
        that.prev_button = function (date_start, options = []) {
            return `
                <button class="week-slide js-week-slide-prev ${options.join(' ')}" data-date="${date_start}">
                    <i class="icon medium fab fa-sa-chevron-left"></i>
                </button>
            `;
        };
        that.next_button = function (date_end, options = []) {
            return `
                <button class="week-slide js-week-slide-next ${options.join(' ')}" data-date="${date_end}">
                    <i class="icon medium fab fa-sa-chevron-right"></i>
                </button>
            `;
        };
        that.day_button = function (day, label, modifiers = [], options = []) {
            var inactive = modifiers.indexOf('loading') !== -1 ? '&nbsp;' : '—',
                href = that.makeUrl(day),
                link = options.indexOf('disabled') !== -1 ? '' : href,
                human_day = that.formatDateToHuman(day),
                label_value = label ? label : inactive,
                label_prefix = $.sa.current_locale_config.code === 'ru' ? that.locales.from : '≈';

            if (label && modifiers.indexOf('unknown') === -1) {
                label_value = label_prefix + '&nbsp;' + label_value;
            }

            return `
                <a href="${link}" class="day-wrapper ${options.join(' ')}">
                    <span class="day">${human_day}</span>
                    <span class="day-label ${modifiers.join(' ')}">${label_value}</span>
                </a>
            `;
        };

        that.day_button_mobile = function (day, label, modifiers = [], options = [], direction) {
            var inactive = modifiers.indexOf('loading') !== -1 ? '&nbsp;' : '—',
                href = that.makeUrl(day),
                link = options.indexOf('disabled') !== -1 ? '' : href,
                human_day = that.formatDateToHuman(day),
                label_value = label ? label : inactive,
                label_prefix = $.sa.current_locale_config.code === 'ru' ? that.locales.from : '≈',
                arrow_left = '',
                arrow_right = '';

            if (direction === 'left') {
                arrow_left = `<span class="day-icon"><i class="icon medium fab fa-sa-chevron-${direction}"></i></span>`;
            }

            if (direction === 'right') {
                arrow_right = `<span class="day-icon"><i class="icon medium fab fa-sa-chevron-${direction}"></i></span>`;
            }

            if (label && modifiers.indexOf('unknown') === -1) {
                label_value = label_prefix + '&nbsp;' + label_value;
            }

            return `
                <a href="${link}" class="day-wrapper ${options.join(' ')}">
                    ${arrow_left}
                    <span class="day-content ${direction}">
                        <span class="day">${human_day}</span>
                        <span class="day-label ${modifiers.join(' ')}">${label_value}</span>
                    </span>
                    ${arrow_right}
                </a>
            `;
        };

        // CONST
        that.FORMAT_DATE = 'YYYY-MM-DD';
        that.offset = {
            desktop: 3,
            tablet: 2,
            mobile: 1,
        };
        that.schedule_depth_month = options['schedule_depth_month'];
        that.locales = options['locales'];

        // DYNAMIC VARS
        that.is_back_direction = options['is_back_direction'];
        that.date = options['date'];
        that.date_back = options['date_back'];
        that.origin = options['origin'];
        that.destination = options['destination'];
        that.passengers = options['passengers'];
        that.can_render = options['can_render'] || function () { return true; };

        that.layout = that.getLayout(); // нужна для того, чтобы понимать на каком экране был первый рендер
        that.is_locked = false; // нужна для блокировки запроса лишнего

        // INIT
        that.init();
    };

    CalendarHorizontal.prototype.init = function () {
        var that = this;

        that.updateCalendar();

        that.initEventHandlers();

        that.initResize();
    };

    CalendarHorizontal.prototype.updateCalendar = function () {
        var that = this,
            offset = that.getOffset(),
            date_start = dayjs(that.getDate()).subtract(offset, 'day').format(that.FORMAT_DATE);

        if (!that.can_render() || !that.getDate()) {
            return
        }

        that.loadPrices(date_start);
    }

    CalendarHorizontal.prototype.getDate = function () {
        var that = this;

        return that.is_back_direction ? that.date_back : that.date;
    };

    CalendarHorizontal.prototype.getOrigin = function () {
        var that = this;

        return that.is_back_direction ? that.destination : that.origin;
    };

    CalendarHorizontal.prototype.getDestination = function () {
        var that = this;

        return that.is_back_direction ? that.origin : that.destination;
    };

    /**
     * Преобразуем параметры в css классы
     * @param {*} params Входящим параметром является обьект параметров { disabled: true, selected: undefined }
     * @returns Возвращает для входящих парамтеров массив классов ['disabled', 'selected']
     */
    CalendarHorizontal.prototype.makeOptions = function (params = {}) {
        var result = [];

        Object.keys(params).forEach(function (key) {
            if (Boolean(params[key])) {
                result.push(key);
            }
        });

        return result;
    }

    CalendarHorizontal.prototype.__countPassengers = function () {
        var that = this,
            sum = 0;

        Object.keys(that.passengers).forEach(function (key) {
            sum += that.passengers[key];
        });

        return sum;
    };

    CalendarHorizontal.prototype.__getSearchParams = function (input_date) {
        var that = this,
            date = that.is_back_direction ? that.date : input_date,
            date_back = that.is_back_direction ? input_date : that.date_back,
            result = {
                directions: [],
                passengers: {
                    count: that.__countPassengers(),
                    values: that.passengers,
                }
            };

        result.directions.push({
            origin: that.origin,
            destination: that.destination,
            date: date,
        });

        if (date_back) {
            result.directions.push({
                origin: that.destination,
                destination: that.origin,
                // Если дата вылета превышает дату возвращения, то мы должны поставить дату вылета
                date: !that.is_back_direction && dayjs(date).isAfter(date_back) ? date : date_back,
            });
        }

        return result;
    }

    /**
     * Генерирует ссылку с учетом параметров и наличия обратного вылета.
     * @returns Пример ответа с готовой ссылкой: search/ARH-1509-MOW-1609-1
     */
    CalendarHorizontal.prototype.makeUrl = function (date) {
        var that = this,
            search_params = that.__getSearchParams(date),
            search_path = $.sa.encodeSearchPath(search_params);

        return $.sa.build_url('search/' + search_path);
    }

    CalendarHorizontal.prototype.getLayout = function () {
        if ($.sa.is_desktop()) {
            return 'desktop';
        }

        if ($.sa.is_tablet(767)) {
            return 'tablet';
        }

        if ($.sa.is_mobile(767)) {
            return 'mobile';
        }
    };

    /**
     * Возвращает смещение слева и справа от выбираемой даты. В зависимости от layout.
     * @returns Например, возврат смещения равного двум: x - x - date - x - x
     */
    CalendarHorizontal.prototype.getOffset = function () {
        var that = this,
            layout = that.getLayout();

        if (layout === 'desktop') {
            return that.offset.desktop;
        }

        if (layout === 'tablet') {
            return that.offset.tablet;
        }

        if (layout === 'mobile') {
            return that.offset.mobile;
        }
    }

    /**
     * Возвращает длину недели по дням. В зависимости от layout.
     * @returns Например, возврат недели равной пяти: x - x - date - x - x
     */
    CalendarHorizontal.prototype.getWeekDayLength = function () {
        var that = this,
            offset = that.getOffset();

        return offset * 2 + 1;
    }

    CalendarHorizontal.prototype.makeSkeleton = function (date, length) {
        var that = this,
            days = that.getSkeletonDays(date, length);

        that.makeTemplate(days);
    }

    CalendarHorizontal.prototype.formatDateToHuman = function (date) {
        return dayjs(date).locale($.sa.current_locale_config.code).format('D MMM, dd').toLowerCase();
    }

    CalendarHorizontal.prototype.makeTemplateDesktop = function (days = []) {
        var that = this,
            $elements = $(),
            prev_day = days[0] || {},
            next_day = days[days.length - 1] || {},
            prev_button_options = that.makeOptions({ disabled: that.isDateDisabled(prev_day.day) }),
            next_button_options = that.makeOptions({ disabled: that.isDateDisabled(next_day.day) });

        // левая кнопка
        $elements = $elements.add(that.prev_button(prev_day.day, prev_button_options));

        // показываем дни
        days.forEach(function (day) {
            $elements = $elements.add(
                that.day_button(day.day, day.value, day.modifiers, day.options)
            );
        })

        // правая кнопка
        $elements = $elements.add(that.next_button(next_day.day, next_button_options));

        // добавляем на экран
        that.$list.empty();
        that.$list.append($elements);
    }

    CalendarHorizontal.prototype.makeTemplateMobile = function (days = []) {
        var that = this,
            $elements = $(),
            prev_day = days[0] || {},
            next_day = days[days.length - 1] || {},
            $prev_block = that.day_button_mobile(prev_day.day, prev_day.value, prev_day.modifiers, prev_day.options, 'left'),
            $next_block = that.day_button_mobile(next_day.day, next_day.value, next_day.modifiers, next_day.options, 'right');

        // добавляем на экран
        $elements = $elements.add($prev_block);
        $elements = $elements.add($next_block);

        that.$list.empty();
        that.$list.append($elements);
    }

    CalendarHorizontal.prototype.makeTemplate = function (days = []) {
        var that = this;

        if ($.sa.is_mobile(767)) {
            that.makeTemplateMobile(days);
        } else {
            that.makeTemplateDesktop(days);
        }
    }

    CalendarHorizontal.prototype.getSkeletonDays = function (date, length) {
        var that = this,
            date_start = dayjs(date),
            elements = [];

        for (x = 0; x < length; x++) {
            var dayFormat = date_start.add(x, 'day').format(that.FORMAT_DATE),
                skeleton_options = that.makeOptions({ selected: dayFormat === that.getDate() });

            elements.push({
                day: dayFormat,
                options: skeleton_options,
                modifiers: ['loading'],
            });
        }

        return elements;
    }

    CalendarHorizontal.prototype.isDateDisabled = function (date) {
        var that = this,
            datetime = dayjs(date);

        // нельзя выбрать вперед от сегодняшней даты на 8 месяцев
        if (datetime.isAfter(dayjs().add(that.schedule_depth_month, 'month'))) {
            return true;
        }

        // можно выбирать только сегодняшнюю дату и дальше
        if (datetime.isBefore(dayjs().subtract(1, 'day'))) {
            return true;
        }

        // для обратного нельзя выбрать назад от даты вылета
        if (that.is_back_direction && datetime.isBefore(dayjs(that.date))) {
            return true;
        }

        return false;
    }

    CalendarHorizontal.prototype.loadPrices = function (date_start) {
        var that = this,
            length = that.getWeekDayLength(),
            date_end = dayjs(date_start).add(length - 1, 'day').format(that.FORMAT_DATE);

        if (that.is_locked) {
            return;
        }
        that.is_locked = true;

        var request_data = {
            origin: that.getOrigin(),
            destination: that.getDestination(),
            calendar_date_start: date_start,
            calendar_date_end: date_end,
            rt: 0
        };

        that.makeSkeleton(date_start, length);

        $.ajax({
            url: $.sa.build_url('search/calendar'),
            method: 'POST',
            async: true,
            data: request_data,
            dataType: 'json'
        })
            .done(function (response) {
                var data = response && response.data || {},
                    // по формату возвращаемых данных нам нужен ключ: [аэропорт вылета]-[аэропорт прилета]
                    days = data[that.getOrigin() + '-' + that.getDestination()],
                    elements = [];

                if (!days) {
                    return
                }

                Object.keys(days).sort().forEach(function (date) {
                    var value = days[date] && days[date].label,
                        result_options = that.makeOptions({ disabled: that.isDateDisabled(date), selected: date === that.getDate() });

                    elements.push({ ...value, day: date, options: result_options })
                });

                that.makeTemplate(elements);
            })
            .fail(function () {
                that.makeSkeleton(date_start, length);
            })
            .always(function () {
                that.is_locked = false;
            });
    }

    CalendarHorizontal.prototype.loadPriceOnWeekSlide = function (date, type) {
        var that = this,
            length = that.getWeekDayLength(),
            date_start = type === 'prev' ? dayjs(date).subtract(length, 'day') : dayjs(date).add(1, 'day');

        that.loadPrices(date_start.format(that.FORMAT_DATE));
    }

    CalendarHorizontal.prototype.initEventHandlers = function () {
        var that = this;

        that.$wrapper.on('click', that.selectors.week_slide_prev, function (e) {
            var $button = $(this),
                date = $button.data('date');

            if (that.isDateDisabled(dayjs(date).subtract(1, 'day'))) {
                return;
            }

            that.loadPriceOnWeekSlide(date, 'prev');
        });

        that.$wrapper.on('click', that.selectors.week_slide_next, function (e) {
            var $button = $(this),
                date = $button.data('date');

            if (that.isDateDisabled(dayjs(date).add(1, 'day'))) {
                return;
            }

            that.loadPriceOnWeekSlide(date, 'next');
        });
    };

    CalendarHorizontal.prototype.initResize = function () {
        var that = this;

        var __resizeHandler = $.debounce(function () {
            var new_layout = that.getLayout();
    
            if (that.can_render() && that.layout !== new_layout) {
                that.layout = new_layout;
    
                that.updateCalendar();
            }
        }, 500)

        $.sa.$window.on('resize', __resizeHandler);

        $.sa.$document.on('wa_before_load', function () {
            $.sa.$window.off('resize', __resizeHandler);
        })
    };

    return CalendarHorizontal;
})($);
